import { render, staticRenderFns } from "./OpportunityView.vue?vue&type=template&id=45517871&"
import script from "./OpportunityView.vue?vue&type=script&lang=js&"
export * from "./OpportunityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports